/**
 * What every COA list read shares on the framework's list contract (FLF-S85): how a list view's query becomes the
 * request's query string.
 *
 * `usePortalModuleList` hands a module's `read` the shared contract (`sort`, `search`, a repeatable `filter`, `page`) with
 * every default omitted. Each COA list operation spreads {@link coaListParams} into its request, so no operation writes
 * the repeated-`filter` handling again: `portalListQueryParameters` is what the transport reads to send `filter` as
 * repeated `filter=` keys, which is how the API's `string[]` binds.
 */
import { portalListQueryParameters } from '@equerranz/portal-api-client';
/**
 * The part of a list request that carries the query: nothing for a caller that asked for no view, so a read with no
 * query sends the request it always sent, and `params.query` otherwise.
 *
 * @param query The view, or undefined for the list's default.
 */
export function coaListParams(query) {
    return query === undefined ? {} : { params: { query: portalListQueryParameters(query) } };
}
//# sourceMappingURL=coaLists.js.map